<template>
    <section class="d-flex flex-column justify-content-between align-content-center h-full mission-information">
        <div class="flex-grow-1 h-full scroll-y">
            <div class="pda-default shadow-bottom" v-if="status === 'UNDER_EVALUATION' || status === 'EVALUATED' || status === 'REJECT'">
                <div v-if="status === 'UNDER_EVALUATION'">
                    <div class="t-subtitle1 ">
                        {{$t('159')}}
                        <!-- 평가 진행 중 -->
                    </div>
                    <div class="t-body3 t-color-content1 mgt-8">
                        {{$t('160')}}
                        <!-- 제출한 과제물을 평가 중입니다. -->
                    </div>
                </div>

                <div v-if="status === 'EVALUATED'">
                    <div class="d-flex align-items-center t-subtitle1">
                        <img src="@/assets/mission_check_icon.svg" alt="" class="icon">
                        <div class="mgl-8 mgr-8 t-color-blue1">
                            {{$t('165')}}
                            <!-- 과제물 평가 완료 -->
                        </div>
                    </div>
                    <div class="t-body3 t-color-content1 mgt-8">
                        {{$t('166')}}
                        {{$t('167')}}
                        <!-- 제출된 과제물 평가가 완료되었습니다. 과제 점수와 피드백을 확인해주세요. -->
                    </div>
                </div>

                <div v-if="status === 'REJECT'">
                    <div class="d-flex align-items-center t-subtitle1">
                        <img src="@/assets/warning_sign_icon.svg" alt="" class="icon">
                        <div class="mgl-8 mgr-8 t-color-red">
                            {{$t('162')}}
                            <!-- 과제물을 다시 제출해주세요. -->
                        </div>
                    </div>
                    <div class="t-body3 t-color-content1 mgt-8">
                        {{$t('163')}}
                        {{$t('164')}}
                        <!-- 제출된 과제물이 반려되었습니다. 과제물을 다시 작성 후 제출해주세요. -->
                    </div>
                </div>
            </div>

            <div class="pda-default">
                <div class="t-subtitle2">
                    {{name}}
                </div>
                <div class="t-body3 t-color-content1 mgt-6">
                    {{description}} 
                </div>
                
                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16" v-if="reference.length">
                    <div class="t-subtitle2">
                        {{$t('123')}}
                        <!-- 참고 자료 -->
                    </div>
                    <div class="t-body3 mgt-30 d-flex flex-row justify-content-between align-content-center"  v-for="(file, index) in reference" :key="index">
                        <div>
                            <img src="@/assets/tip.svg" alt="" class="icon">
                        </div>
                        <div class="flex-grow-1 mgl-4 mgr-4 t-color-gray2 t-line-1">
                            {{file.originalName}}
                        </div>
                        <div>
                            <img src="@/assets/download_icon.svg" alt="download" class="icon" @click="donwloadFile(file)">
                        </div>
                    </div>
                </div>
                

                <div class="t-body3 mgt-16 d-flex flex-row justify-content-between align-content-center">
                    <div>
                        {{$t('124')}}
                        <!-- 제출 마감일 -->
                    </div>
                    <div class="t-color-content1">
                        {{$moment(learnEndDate).format('ll')}}
                    </div>
                </div>
            </div>

            <hr class="divider">

            <div class="pda-default" v-if="answer">
            
                <div class="t-subtitle2 mgt-4">
                    {{$t('157')}}
                    <!-- 제출한 과제물 -->
                </div>
                
                <div class="t-body3 t-color-content1 mgt-8 pda-default answer-box" v-if="answer.text">
                    <pre>{{answer.text}}</pre>
                </div>


                <div class="t-body3 mgt-16 d-flex flex-row justify-content-between align-content-center"  v-for="(file, index) in answer.file" :key="index">
                    <div>
                        <img src="@/assets/tip.svg" alt="" class="icon">
                    </div>
                    <div class="flex-grow-1 mgl-8 mgr-8 t-color-content1 t-line-1">
                        <a :href="file.resourceUri" target="_blank">
                            {{file.originalName}}
                        </a>
                    </div>
                    <!-- <div>
                        <img src="@/assets/download_icon.svg" alt="download" @click="donwloadFile(file)">
                    </div> -->
                </div>
            </div>

            <!-- {{eval}}             -->

            <div class="pdl-16 pdr-16 pdb-16 mgt-16" v-if="eval">
                <div class="mdc-card mdc-elevation--z2 pdt-17 pdb-17">
                    <div class="d-flex flex-row justify-content-between align-items-center graph-row mgt-8 mgt-8">
                        <div class="t-body3 pdr-16 pdl-16">
                            {{$t('161')}}
                            <!-- 과제점수 -->
                        </div>
                        <div class="rowline"></div>
                        <div class="flex-grow-1 d-flex flex-row justify-content-between align-items-center">
                            <div class="graph d-flex flex-row justify-content-between align-items-center">
                                <div class="guideline"></div>
                                <div class="pointline" :style="`width:${eval.score}%;`"></div>
                            </div>
                        </div>
                        <div class="t-headline5 pdr-16 pdl-16">
                            {{eval.score}}
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        
        <div class="">
            <div class="pda-default">
                <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="moveSubmit()"  v-if="isSubmit">
                    {{$t('125')}}
                    <!-- 과제물 작성하기 -->
                </button>
                <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="moveUpdate()"  v-else-if="isUpdate">
                    {{$t('158')}}
                    <!-- 다시 제출하기 -->
                </button>
                <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="moveList()"  v-else>
                    {{$t('168')}}
                    <!-- 확인 -->
                </button>
            </div>
        </div>
    </section>




    
</template>

<script>
/**
 * 나의 학습 상세 - 미션 상세 정보 컴포넌트(my learning view - mission view information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { fileMixin } from '@/mixins/file.js'

export default {
    props: ['name', 'description', 'reference', 'answer', 'eval', 'learnEndDate', 'status'],
    mixins: [fileMixin],
    computed: {
        // 제출 상태(submit status)
        isSubmit() {
            return this.status === 'REJECT' || this.status === null
        },

        //  수정 상태(update status)
        isUpdate() {
            return !!this.answer && (this.status === 'SUBMISSIBLE' || this.status === 'SUBMITTED' || this.status === 'UNDER_EVALUATION')
        }
    },
    methods: {
        // 제출 이동(move submit)
        moveSubmit() {
            this.$router.push({
                name: 'LearnViewMissionSubmit',
                query: this.$route.query
            })
        },

        // 수정 이동(move update)
        moveUpdate() {
            this.$router.push({
                name: 'LearnViewMissionUpdate',
                params: {
                    learnId: this.$route.params.learnId,
                    assignmentId: this.$route.params.assignmentId,
                    answerId: this.answer.id
                },
                query: this.$route.query
            })
        },

        // 목록 이동(move list)
        moveList() {
            this.$router.push({
                name: 'LearnView',
                params: {
                    learnId: this.$route.params.learnId,
                },
                query: this.$route.query
            })
        },
        
    }
}
</script>